import precision from './precision.js';

export default {
    precision
}